import React, { lazy } from 'react';
import { Phone } from 'lucide-react';
export function AccidentsHappen() {
  return <section className="bg-white border-b border-slate-200 overflow-hidden" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center py-12 lg:py-16" data-id="element-136">
          <div className="text-center lg:text-left order-2 lg:order-1 scroll-slide-left" data-id="element-137">
            <h2 className="text-3xl md:text-5xl font-bold text-navy-900 mb-4 leading-tight" data-id="element-138">
              Accidents Happen.
              <br data-id="element-139" />
              <span className="text-brand-blue" data-id="element-140">We Fix Them.</span>
            </h2>
            <p className="text-lg text-slate-600 mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-141">
              From rock chips on the highway to shattered windows in the
              driveway, Kosin's Glass repairs and replaces auto glass for cars,
              trucks and SUVs across Southeast Michigan.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-142">
              <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold py-3 px-6 rounded-xl transition-colors shadow-lg shadow-brand-blue/20" data-id="element-143">
                Get a Free Quote
              </a>
              <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-white border-2 border-slate-200 hover:border-brand-blue text-navy-900 font-bold py-3 px-6 rounded-xl transition-colors" data-id="element-144">
                <Phone className="w-4 h-4" data-id="element-145" />
                517-545-7772
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative scroll-fade-scale" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/5GZJEbefwz2EYdYEfUvFir/autoglasspic1.webp" alt="Red Cadillac Escalade SUV. Kosin's Glass services foreign and domestic vehicles." className="block w-full h-auto object-contain" loading="lazy" data-id="element-147" />
          </div>
        </div>
      </div>
    </section>;
}